import { Component, OnInit, ViewEncapsulation, Output, EventEmitter } from '@angular/core';
import { FilterItemsService } from "../shared/filter-items.service";
import { StorageService } from "../core/services/index";
import { consts } from "../shared/consts";
import { AssetFilterModel } from './asset-filter.model';

@Component({
    moduleId: module.id,
    selector: 'asset-filter',
    templateUrl: 'asset-filter.component.html',
    encapsulation: ViewEncapsulation.None
})
export class AssetFilterComponent implements OnInit {
    disabledButtons: boolean = true;
    name: string = '';
    private filters: AssetFilterModel;

    @Output() filterChanged: EventEmitter<AssetFilterModel>;

    constructor(
        private filterItemsService: FilterItemsService,
        private storageService: StorageService) {
        this.filterChanged = new EventEmitter<AssetFilterModel>();
    }

    ngOnInit() {
        this.initFilters();
        this.disable();
    }

    disable() {
        this.disabledButtons = true;
    }

    enable() {
        this.disabledButtons = false;
    }

    public onResetFilters(event) {
        //remove values from storage
        this.storageService.remove(consts.PublisherIdsFilterStorageKey);
        //reset selected values in filters
        this.name = '';
        this.filters = new AssetFilterModel(this.name, this.filterItemsService.getPublishersIds());
        this.filterChanged.emit(this.filters);
    }

    public onPublishersChanged(publisherIds) {
        this.filters.publisherIds = publisherIds;
        if (this.filterItemsService.getPublishersIds().length === publisherIds.length)
            this.storageService.remove(consts.PublisherIdsFilterStorageKey);
        else {
            this.storageService.set(consts.PublisherIdsFilterStorageKey, this.filters.publisherIds);
        }
        this.filterChanged.emit(this.filters);
    }

    public onFilter(event) {
        this.filters.name = this.name;
        this.filterChanged.emit(this.filters);
    }

    private initFilters(): void {
        this.name = '';
        let publisherIds = this.filterItemsService.getPublishersIds();
        this.filters = new AssetFilterModel(this.name, publisherIds);
        this.filterChanged.emit(this.filters);
    }
}


// WEBPACK FOOTER //
// ./src/app/assets/asset-filter.component.ts